import React, { useState, useEffect } from "react";
import styles from "./TextReceipt.module.css";
import FireboardUtils from "../../../../util/fireboard-util";
import PopupHeader from '../../../../components/PopupHeader';
import BulletButton from '../../../../components/BulletButton';
import { CountryPicker, getPickerData } from "../../../../components/CountryPicker";

const US_COUNTRY_CODE = 'us';
const UK_COUNTRY_CODE = 'gb';

export default function TextReceipt(props) {
  const { onPressTextReceipt = () => { }, closePopup, currency = '$', defaultPhoneNumber } = props;

  const [phoneNumber, setPhoneNumber] = useState("");
  const [selectedCountry, setSelectedCountry] = useState({});

  useEffect(() => {
    setPhoneNumber(defaultPhoneNumber || "");
    setDefaultCountry();
  }, []);

  const setDefaultCountry = () => {
    const countriesData = getPickerData();
    const countryCode = currency === '£' ? UK_COUNTRY_CODE : US_COUNTRY_CODE;
    const defaultCountry = countriesData.find(country => country.iso2 === countryCode);
    setSelectedCountry(defaultCountry);
  }

  const onCountryChange = country => {
    const formattedPhoneNumber = FireboardUtils.inputFormattedPhnNum(phoneNumber, country.iso2);
    setSelectedCountry(country);
    setPhoneNumber(formattedPhoneNumber);
  };

  const onDone = () => {
    onPressTextReceipt &&
      onPressTextReceipt({
        phoneNumber: phoneNumber,
        selectedCountry: selectedCountry,
      });
  };

  return (
    <div className={styles.container}>
      <PopupHeader onClose={closePopup} />
      <div className={styles.wrapper}>
        <span className={styles.label}>Please enter your phone number</span>
        <div>
          <CountryPicker
            selectedCountry={selectedCountry}
            onCountryChange={onCountryChange}
            containerStyle={styles.countryPicker} />
        </div>
        <input
          type="tel"
          value={FireboardUtils.inputFormattedPhnNum(phoneNumber, selectedCountry.iso2)}
          onChange={e => setPhoneNumber(e.target.value)}
          className={styles.input}
        />
        <BulletButton
          direction={'right'}
          triangleBgColor={'#6AB301'}
          buttonStyle={styles.noReceiptBackground}
          onClick={onDone}
        >
          <span className={styles.text}>DONE</span>
        </BulletButton>
      </div>
    </div>
  );
};
